<div class="StoreListPage">


    <div class="gridHolder">
        <kendo-grid
                (cellClick)='gridCellClicked($event)'
                (dataStateChange)="dataStateChange($event)"
                (pageChange)="pageChange($event)"
                (selectionChange)='onSelectionChange($event)'
                [data]="storeList"
                [filterable]="false"
                [groupable]="false"
                [kendoGridSelectBy]="'customerId'"
                [loading]="loading"
                [pageSize]="_storeListService.PAGE_SIZE"
                [pageable]="true"
                [reorderable]="true"
                [resizable]="true"
                [selectable]="{ checkboxOnly: false, mode: 'single' }"
                [selectedKeys]="_storeListService.selection"
                [skip]="state.skip"
                [sort]="state.sort"
                [sortable]="true"
                id="grid-storeList"
                style="height: 73vh">
            <ng-container *ngFor="let col of columns">
                <ng-container *ngIf="col.field == 'identity'">
                    <kendo-grid-column [field]="col.field" [title]="col.title" class='cust-store'>
                    </kendo-grid-column>
                </ng-container>
                <ng-container *ngIf="col.field != 'identity'">
                    <kendo-grid-column [editable]="false" [field]="col.field" [format]="col.format" [title]="col.title">
                    </kendo-grid-column>
                </ng-container>
            </ng-container>
        </kendo-grid>
    </div>

    <!-- <div class="bottomHolder">
        <div class="dataChangers">


        </div>

        <div class="buttonHolder">
            <div class="buttonflex">
                <mcl-button (buttonPressed)="sendSelectedOrders()" icon="send" id="btn-sendSelected" text="Send Selected Saved Orders to McLane" ></mcl-button>

            </div>

        </div>
    </div> -->
</div>
<div kendoDialogContainer></div>
